import React from "react";

const TrackOrder = () => {
  return (
    <div className="tvnl-shipment-track">
      <h2 className="tvnl-track-title">Shipment Track</h2>

      <div className="tvnl-track-card">
        <div className="tvnl-track-header">
          <h4>
            ORDER TRACKING : <span>#ORD-10245</span>
          </h4>
        </div>

        <div className="tvnl-track-info">
          <p>
            <strong>Shipped Via:</strong> BlueDart
          </p>
          <p>
            <strong>Status:</strong> Checking Quality
          </p>
          <p>
            <strong>Expected Date:</strong> 7 Nov 2025
          </p>
        </div>

        <div className="tvnl-track-steps">
          <div className="tvnl-step completed">
            <span className="tvnl-step-icon">✔</span>
            <p>Confirmed Order</p>
          </div>

          <div className="tvnl-step completed">
            <span className="tvnl-step-icon">✔</span>
            <p>Processing Order</p>
          </div>

          <div className="tvnl-step active">
            <span className="tvnl-step-icon">⏳</span>
            <p>Quality Check</p>
          </div>

          <div className="tvnl-step">
            <span className="tvnl-step-icon">🚚</span>
            <p>Dispatched Item</p>
          </div>

          <div className="tvnl-step">
            <span className="tvnl-step-icon">📦</span>
            <p>Product Delivered</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrackOrder;